import { v4 as uuidv4 } from "uuid";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface SkeletonLoaderProps {
  height?: string;
  loaderClassName?: string;
  rows?: number;
  width?: string;
  wrapperClassName?: string;
}

export const SkeletonLoader = ({
  rows = 1,
  wrapperClassName = "",
  loaderClassName = "",
  width = "100%",
  height = "24px",
}: SkeletonLoaderProps) => {
  // Generate unique IDs for each skeleton row
  const skeletonIds = Array.from({ length: rows }, () => uuidv4());

  return (
    <div
      className={classNames(
        "animate-pulse space-y-2 px-6 last:pb-4",
        wrapperClassName,
      )}
    >
      {skeletonIds.map(id => (
        <div
          key={id}
          className={classNames("bg-secondary rounded-md", loaderClassName)}
          style={{ width, height }}
        />
      ))}
    </div>
  );
};
